import React, { type FC } from 'react';
import { Login, useAuth } from '../../auth';

export const AppLogin: FC = () => {
  const { signInWithEmail } = useAuth();

  return <Login signInWithEmail={signInWithEmail} />;
};
